export default "__VITE_ASSET__BMQyCWMe__"